import { render, staticRenderFns } from "./Weicai.vue?vue&type=template&id=23ea1f34&scoped=true&"
import script from "./Weicai.vue?vue&type=script&lang=js&"
export * from "./Weicai.vue?vue&type=script&lang=js&"
import style0 from "./Weicai.vue?vue&type=style&index=0&id=23ea1f34&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ea1f34",
  null
  
)

export default component.exports